import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '16px'
  },
  content: {
    textAlign: 'center',
    marginBottom: 48,
    zIndex: 1
  },
  message: {
    fontSize: 28,
    lineHeight: '36px'
  },
  logoContainer: {
    zIndex: 1
  },
  logoBackground: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '250px',
    opacity: 0.05,
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
    zIndex: 0
  },
  '@media (max-width: 640px)': {
    content: {
      marginBottom: 32
    },
    message: {
      fontSize: 24,
      lineHeight: '32px'
    },
    logo: {
      width: '70vw',
      maxWidth: 300
    },
    logoBackground: {
      width: '260px',
      opacity: 0.06
    }
  }
}));

export default useStyles;
